
import {defineComponent, Ref, ref} from "vue";
import ContentList from "./ContentList.vue";
import BoxMenu from "./menu/BoxMenu.vue";
import ContentAnnotation from "./ContentAnnotation.vue";
import ButtonTab from "./menu/ButtonTab.vue";

export default defineComponent({
  components: {
    ButtonTab,
    ContentAnnotation,
    BoxMenu,
    ContentList
  },

  setup() {
    const isMenuOpen: Ref<boolean> = ref(true);
    const onClickMenuButton = (): void => {
      isMenuOpen.value = !isMenuOpen.value;
    };

    const onClickButtonContent = () => {
      activeContentList();
      inactiveContentAnnotation();
    }

    const onClickButtonAnnotation = () => {
      activeContentAnnotation();
      inactiveContentList();
    }

    const isContentListActive: Ref<boolean> = ref(true);
    const activeContentList = (): void => {
      isContentListActive.value = true;
    };

    const inactiveContentList = (): void => {
      isContentListActive.value = false;
    };

    const isContentAnnotationActive: Ref<boolean> = ref(false);
    const activeContentAnnotation = (): void => {
      isContentAnnotationActive.value = true;
    };

    const inactiveContentAnnotation = (): void => {
      isContentAnnotationActive.value = false;
    };

    return {
      isMenuOpen,
      isContentListActive,
      isContentAnnotationActive,
      onClickMenuButton,
      onClickButtonContent,
      onClickButtonAnnotation,
    };
  }
});
